import React from 'react';

import {Button} from 'primereact/button';
import {Toast} from 'primereact/toast';
import {AutoComplete} from 'primereact/autocomplete';

import Api from '../utils/Api';
import {isWriter} from '../utils/utils.js'
import {processError} from '../utils/errors';
import { Delivery, FuelDeliverer, FuelSeller } from '@/utils/Interfaces';

type MyProps = any;

interface MyState {
  fuel_seller: FuelSeller
  fuel_seller_suggestions: FuelSeller[]
  fuel_sellers: FuelSeller[]
  
  fuel_deliverer: FuelDeliverer
  fuel_deliverer_suggestions: FuelDeliverer[]
  fuel_deliverers: FuelDeliverer[]

  fuel_deliverer_reg_number: string
  fuel_deliverer_reg_number_suggestions: string[]
}

class LogitisticsUpdate extends React.Component<MyProps, MyState> {

  public api = new Api();
  public toast: Toast;
  
  constructor(props) {
    super(props);
    var delivery= props.delivery;
    this.state = {
      fuel_seller: delivery.fuel_seller || {name: ''},
      fuel_deliverer: delivery.fuel_deliverer || {name: ''},
      fuel_deliverer_reg_number: delivery.fuel_deliverer_reg_number || '',
      fuel_seller_suggestions: [],
      fuel_sellers: [],
      fuel_deliverer_suggestions: [],
      fuel_deliverers: [],
      fuel_deliverer_reg_number_suggestions: [],
    }
    
    this.suggestRegNumbers = this.suggestRegNumbers.bind(this);
    this.suggestFuelDeliverers = this.suggestFuelDeliverers.bind(this);
    this.suggestFuelSellers = this.suggestFuelSellers.bind(this);
  }

  componentDidMount() {
    if (!isWriter()) return ;
    this.refreshFuelContractors();
  }



  refreshFuelContractors() {
    this.api.fuelSellers.list().then((data: FuelSeller[]) => {
      // We can't consume the sellers directly because they need to have *exactly* the same
      // keys as those found in the Delivery serializer (i.e. minus the 'count' properties.
      // For this reason, build a new list with only the required fields.
      let fuelSellers = [];
      data.forEach((seller) => {
        fuelSellers.push({id: seller.id, name: seller.name});
      })
      this.setState({fuel_sellers: fuelSellers});
    }).catch((error) => {
      processError(error, this);
    });

    this.api.fuelDeliverers.list().then((data: FuelDeliverer[]) => {
      let fuelDeliverers = [];
      data.forEach((deliverer) => {
        fuelDeliverers.push({id: deliverer.id, name: deliverer.name});
      })
      this.setState({fuel_deliverers: fuelDeliverers});
    }).catch((error) => {
      processError(error, this);
    });
  }

  // filter the total list of fuel_sellers according to the user input
  suggestFuelSellers(event) {
    let results = this.state.fuel_sellers.filter((seller) => {
         return seller.name.toLowerCase().indexOf(event.query.toLowerCase()) > -1;
    });
    results = results.map((value) => value);
    this.setState({ fuel_seller_suggestions: results });
  }

  // filter the total list of fuel_deliverers according to the user input
  suggestFuelDeliverers(event) {
    let results = this.state.fuel_deliverers.filter((deliverer) => {
         return deliverer.name.toLowerCase().indexOf(event.query.toLowerCase()) > -1;
    });
    results = results.map((value) => value);
    this.setState({ fuel_deliverer_suggestions: results });
  }

  // provide a unique list of fuel deliverer rego numbers for the autocomplete
  suggestRegNumbers(event) {
    this.api.fuelDelivererRegNumbers.list(event.query).then((data) => {
      this.setState({fuel_deliverer_reg_number_suggestions: data});
    }).catch((error) => {
      processError(error, this);
    });
  }

  render() {
    // this component is only available for writer users
    if (!isWriter()) return '';

    return (
      <div style={{marginBottom: '20px'}}>
        <Toast ref={(el) => {this.toast = el}} />

        <h2>Logistiques:</h2>
        <div className="grid fluid  align-items-end vertical-container">
          <div className="sm:col-12 md:col-6 lg:col-3">
            <div>
              Vendeur:
            </div>
            <AutoComplete 
              name='fuel_seller'
              value={this.state.fuel_seller} 
              suggestions={this.state.fuel_seller_suggestions}
              completeMethod={this.suggestFuelSellers}
              onChange={(event) => this.setState({
                fuel_seller: event.target.value
              })}
              field="name"
              className="flex"
              placeholder="Choisissez un vendeur"
              dropdown
              appendTo={document.body}
              />
          </div>
          <div className="sm:col-12 md:col-6 lg:col-3">
            <div>
              Livreur:
            </div>
            <AutoComplete 
              name='fuel_deliverer'
              value={this.state.fuel_deliverer} 
              suggestions={this.state.fuel_deliverer_suggestions}
              completeMethod={this.suggestFuelDeliverers}
              onChange={(event) => this.setState({
                fuel_deliverer: event.target.value
              })}
              field="name"
              className="flex"
              placeholder="Choisir un livreur"
              dropdown
              appendTo={document.body}
              />
          </div>
          <div className="sm:col-12 md:col-6 lg:col-3">
            <div>
              Livreur nº immatriculation:
            </div>
            <AutoComplete name='fuel_deliverer_reg_number' value={this.state.fuel_deliverer_reg_number || ''} 
              suggestions={this.state.fuel_deliverer_reg_number_suggestions}
              className="flex"
              completeMethod={this.suggestRegNumbers}
              dropdown
              onChange={(event) => this.setState({
                fuel_deliverer_reg_number: event.target.value
              })} />
          </div>
          <div className="sm:col-12 md:col-6 lg:col-3">
            <Button label='Enregistrer' className="w-full" onClick={() => {
              this.api.deliveries.update(this.props.delivery.id, {
                fuel_seller: this.state.fuel_seller,
                fuel_deliverer: this.state.fuel_deliverer,
                fuel_deliverer_reg_number: this.state.fuel_deliverer_reg_number
              }).then((delivery: Delivery) => {
                this.toast.show({severity: 'success', summary: 'Succès', detail: 'Livraison mise à jour'});
                this.props.updateDeliveryInState(delivery);
                this.setState({
                  fuel_seller: delivery.fuel_seller,
                  fuel_deliverer: delivery.fuel_deliverer,
                  fuel_deliverer_reg_number: delivery.fuel_deliverer_reg_number,
                })
              }).catch((error) => {
                processError(error, this);
              });;
              }
            }/>
          </div>
        </div>
      </div>
    )

  };

}

export default LogitisticsUpdate;
